/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as cx from "classnames";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IApi } from "../../api/api";
import { APP_PATH, IConfirmPhoneNumberRouteParams } from "../../paths/pathIndex";
import { CloseButton } from "../modal/closeButton";

interface IProps {
    api: IApi;
    routeParams: IConfirmPhoneNumberRouteParams;
    userInfo: UserInfo;
}

interface IState {
    updateInProgress: boolean;
    verificationPin: string | undefined;
}

class ConfirmPhoneNumberWithoutRouter extends React.PureComponent<IProps & RouteComponentProps<any>, IState> {
    private static readonly PIN_FORMAT = /^\d{4}$/;
    private static readonly PIN_LENGTH = 4;

    public state: IState = {
        updateInProgress: false,
        verificationPin: undefined,
    };

    public render() {
        return (
            <span className="scpr-ConfirmPhoneNumber">
                <h2>
                    Enter verification PIN

                    <CloseButton />
                </h2>

                <div className="divider"></div>

                <div className="section">
                    {this.renderForm()}
                </div>
            </span>
        );
    }

    private renderForm() {
        const { updateInProgress, verificationPin } = this.state;
        const { warn, valid } = this.isVerificationPinValid();
        const submitDisabled = !valid || updateInProgress;
        return (
            <>
                <input
                    className={cx({ disabled: updateInProgress, error: warn })}
                    onChange={this.handleVerificationPinChange}
                    placeholder={`${ConfirmPhoneNumberWithoutRouter.PIN_LENGTH}-digit PIN`}
                    type="number"
                    value={verificationPin || ""}
                />

                <button
                    className={cx("btn-large waves-effect waves-light right", { disabled: submitDisabled })}
                    onClick={this.submitVerificationPin}
                    type="submit"
                >
                    Submit verification PIN
                    <i className="material-icons right">send</i>
                </button>
            </>
        );
    }

    private handleVerificationPinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const verificationPin = event.target.value;
        this.setState({ verificationPin });
    };

    private isVerificationPinValid(): { reason?: string, valid: boolean, warn?: boolean } {
        const { verificationPin } = this.state;

        if (verificationPin == null) {
            return {
                reason: "PIN required",
                valid: false,
            };
        }

        if (verificationPin.length < ConfirmPhoneNumberWithoutRouter.PIN_LENGTH) {
            return {
                reason: "Too short",
                valid: false,
            };
        }

        if (verificationPin.length > ConfirmPhoneNumberWithoutRouter.PIN_LENGTH) {
            return {
                reason: "Too long",
                valid: false,
                warn: true,
            };
        }

        const isFormatted = ConfirmPhoneNumberWithoutRouter.PIN_FORMAT.test(verificationPin);
        if (!isFormatted) {
            return {
                reason: "Invalid format",
                valid: false,
                warn: true,
            };
        }

        return { valid: true };
    }

    private submitVerificationPin = () => {
        const { api } = this.props;
        const { verificationPin } = this.state;
        const { valid } = this.isVerificationPinValid();

        if (!valid) {
            return;
        }

        this.setState({ updateInProgress: true });
        api.userService.confirmPhoneNumber(verificationPin!).then(this.redirect).catch(() => {
            this.setState({ updateInProgress: false });
        });
    };

    private redirect = () => {
        const { history, routeParams } = this.props;
        const { from } = routeParams;
        const path = from != null ? from : APP_PATH;
        history.replace(path);
    }
}

export const ConfirmPhoneNumber = withRouter(ConfirmPhoneNumberWithoutRouter);
